import React, { useState, useMemo } from 'react';

import {
  format,
  subDays,
  setHours,
  setMinutes,
  setSeconds,
  parseISO,
} from 'date-fns';

import { Button } from '@material-ui/core';

import { isEmpty } from 'lodash';
import qs from 'querystring';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { DateTime } from '~/components/Form';

import api from '~/services/api';

import { TableSearchListdDef } from '~/componentslocal/';
import * as S from './styles';

const schema = Yup.object().shape({
  datahorainicial: Yup.string().required(),
  datahorafinal: Yup.string().required(),
});

function DlgRelLogAcesso() {
  const [logs, setLogs] = useState([]);
  const [dets, setDets] = useState([]);
  const [datahorainicial, setDatahorainicial] = useState(
    format(
      setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
      'dd/MM/yyyy HH:mm:ss'
    )
  );
  const [datahorafinal, setDatahorafinal] = useState(
    format(
      setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
      'dd/MM/yyyy HH:mm:ss'
    )
  );
  const { loading } = useState(false);

  const header = useMemo(
    () => [
      {
        id: 'mant_cod_mant',
        label: 'Mantenedora',
      },
      {
        id: 'usua_nome',
        label: 'Usuário',
      },
      {
        id: 'loac_data',
        label: 'Último Acesso',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'acessos',
        label: 'Acessos no Período',
      },
    ],
    []
  );

  const headerDet = useMemo(
    () => [
      {
        id: 'loac_data',
        label: 'Data',
      },
      {
        id: 'tarefa',
        label: 'Tarefa',
      },
    ],
    []
  );

  async function handleSubmit({ datahorainicial, datahorafinal }) {
    let params = {
      datahorainicial: datahorainicial,
      datahorafinal: datahorafinal,
    };

    const response = await api.get('consulta/log', {
      params: { ...params },
      paramsSerializer: (param) => qs.stringify(param),
    });

    if (!isEmpty(response.data)) {
      setLogs(response.data);
    }
  }

  async function handleDetalhe(data, { datahorainicial, datahorafinal }) {
    let params = {
      usua_cod_usua: data.usua_cod_usua,
      datahorainicial: datahorainicial,
      datahorafinal: datahorafinal,
    };

    const response = await api.get('consulta/log/detalhe', {
      params: { ...params },
      paramsSerializer: (param) => qs.stringify(param),
    });

    if (!isEmpty(response.data)) {
      setDets(response.data);
    }
  }

  return (
    <>
      <Form
        schema={schema}
        onSubmit={handleSubmit}
        initialData={{
          datahorainicial: datahorainicial,
          datahorafinal: datahorafinal,
        }}
      >
        <S.Columns grid={3}>
          <DateTime time name="datahorainicial" label="Data/Hora inicial" />
          <DateTime time name="datahorafinal" label="Data/Hora final" />
          <Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            disabled={loading}
            style={{ maxWidth: '50px' }}
            onClick={() => setDets([])}
          >
            {loading ? 'Carregando...' : 'OK'}
          </Button>
        </S.Columns>
      </Form>
      {dets.length == 0 && (
        <>
          <S.WrapperTables>
            <TableSearchListdDef
              title="Relatório de acesso de usuários"
              cells={header}
              data={logs}
              size="xs"
              paginate={99999}
              showCount
              search
              onRow={(value) =>
                handleDetalhe(value, { datahorainicial, datahorafinal })
              }
            />
          </S.WrapperTables>
        </>
      )}
      {dets.length > 0 && (
        <>
          <S.WrapperTables>
            <TableSearchListdDef
              title="Relatório de acesso de usuários"
              cells={headerDet}
              data={dets}
              size="xs"
              paginate={10}
              showCount
              search
            />
          </S.WrapperTables>
          <div align="right">
            <Button
              color="primary"
              variant="contained"
              fullWidth
              style={{ marginTop: '10px', maxWidth: '50px' }}
              onClick={() => setDets([])}
            >
              Voltar
            </Button>
          </div>
        </>
      )}
    </>
  );
}

export default DlgRelLogAcesso;
